import type { ConditionModel } from '.';
import type { Formula, IfThenLine } from '@thinkalpha/platform-ws-client/contracts/ideas/index.js';
import type { NaturalLanguageAtomState } from 'src/features/nlp/types/naturalLanguageAtomState';

const naturalLanguageAtomStateToFormula = (naturalLanguageAtomState: NaturalLanguageAtomState): Formula => {
    if (naturalLanguageAtomState.atom.status === 'user_code') {
        return {
            fieldInView: 'formula',
            formula: naturalLanguageAtomState.atom.code,
            naturalLanguage: naturalLanguageAtomState.naturalLanguage,
        };
    } else if (naturalLanguageAtomState.atom.status === 'confirmed') {
        return {
            fieldInView: 'nlp',
            formula: naturalLanguageAtomState.atom.confirmedFormula,
            naturalLanguage: naturalLanguageAtomState.naturalLanguage,
        };
    } else if (naturalLanguageAtomState.atom.status === 'writing') {
        return {
            fieldInView: 'nlp',
            naturalLanguage: naturalLanguageAtomState.naturalLanguage,
        };
    }

    return {
        fieldInView: 'nlp',
        naturalLanguage: naturalLanguageAtomState.naturalLanguage,
    };
};

export const conditionModelToIfThenLine = (conditionModel: ConditionModel): IfThenLine => {
    const { conditionState } = conditionModel;
    if (conditionState.type === 'guided') {
        return {
            id: conditionModel.id,
            description: null,
            enabled: conditionModel.isSelfEnabled,
            type: 'line',
            mode: 'guided',
            lhs: naturalLanguageAtomStateToFormula(conditionState.lhs),
            operator: conditionState.operator,
            rhs: naturalLanguageAtomStateToFormula(conditionState.rhs),
        };
    }

    return {
        id: conditionModel.id,
        description: null,
        enabled: conditionModel.isSelfEnabled,
        type: 'line',
        mode: 'formula',
        ...naturalLanguageAtomStateToFormula(conditionState.state),
    };
};
